import { ModuleUebersicht, type ModuleCfg } from './ModuleUebersicht';

const cfg: ModuleCfg = {
  path: 'laufraeder',
  label: 'Laufräder',
  breadcrumb: 'Produktion',
  extraColumns: [
    { key: 'material_typ', label: 'Material' },
    { key: 'wuchten',      label: 'Wuchten' },
    { key: 'lackieren',    label: 'Lack' },
    { key: 'ral_farbe',    label: 'RAL' },
  ],
};

export function Laufraeder() {
  return <ModuleUebersicht cfg={cfg} />;
}
